import React from 'react'

import PropTypes from 'prop-types'

import { useT } from '@galo-monitor/i18n'
import { arrowUp } from '@galo-monitor/icons'
import { colors } from '@galo-monitor/styles'
import Icon from '@galo-monitor/web-components/Icon'

import IconButton from '../IconButton'

const ArrowUpIconButton = ({ iconColor, ...props }) => {
  const t = useT()
  return (
    <IconButton tooltip={ t('retract') } { ...props }>
      <Icon icon={ arrowUp } color={ iconColor } />
    </IconButton>
  )
}

ArrowUpIconButton.propTypes = {
  iconColor: PropTypes.string
}

ArrowUpIconButton.defaultProps = {
  iconColor: colors.mutedText
}

export default ArrowUpIconButton
